module.exports = __webpack_public_path__ + "img/donante-costco.2cfece77.png";